import { render } from "./ImportFromArea.vue?vue&type=template&id=7ab66d3a"
import script from "./ImportFromArea.vue?vue&type=script&lang=js"
export * from "./ImportFromArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__